module.exports = __webpack_public_path__ + "media/assets/images/arrow-down-pink-f31f48e7cba898d86e1e8cf4cd8115a9.png";